import React from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import YouTube from 'react-youtube';
import Vimeo from '@u-wave/react-vimeo';

const Popup = props => {
    const {
        modalOpen,
        setModalOpen,
        video,
        setVideo
    } = props;
    const toggle = () => setModalOpen(!modalOpen);

    let component = null;

    if (video) {
        switch (video.type) {
            case "image":
                component = <img onClick={() => {
                    setModalOpen(false);
                }} src={video.url} alt={video.title} />;
                break;
            case "YouTube":
                component = <YouTube
                    videoId={video.url}
                    id={video.title}
                    opts={
                        {
                            width: "100%",
                            playerVars: {
                                autoplay: 1
                            }
                        }
                    }
                    onEnd={() => {
                        setModalOpen(false);
                        setVideo(null);
                    }}
                />;
                break;
            case "Vimeo":
                component = <div>
                    <Vimeo
                        video={video.url}
                        autoplay
                        responsive={true}
                        onEnd={() => {
                            setModalOpen(false);
                            setVideo(null);
                        }}
                    />
                </div>;
                break;
            default:
                component = <video onEnded={() => {
                    setModalOpen(false);
                    setVideo(null);
                }} controls="controls" autoPlay style={{
                    width: "100%",
                    maxHeight: "80VH"
                }}>
                    <source src={video.url} type={video.type} />
                </video>;
                break;
        }
    }

    return (
        <Modal toggle={toggle} isOpen={modalOpen} className="full-screen-modal">
                {
                    (
                        video
                        ?
                            <>
                                <ModalHeader 
                                    toggle={toggle}
                                    style={{
                                        width: "100%"
                                    }}
                                >
                                    {video.title}

                                </ModalHeader>
                                <ModalBody className="p-0 m-0">
                                    {
                                        component
                                    }
                                </ModalBody>
                            </>
                        : undefined
                    )
                }
            </Modal>
    )
}

export default Popup
